import axios from 'axios'

export default {
    async fetchAll() {
        return await axios.get(`master-bank`)
    },
    async fetchByPermission() {
        return await axios.get(`master-bank/fetchby/permission`)
    },
    async create(model) {
        return await axios.post(`master-bank`, model)
    },
    async fetchById(id) {
        return await axios.get(`master-bank/${id}`)
    },

    async update(id, model) {
        return await axios.put(`master-bank/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`master-bank/${id}`)
    },


}
